import { createFileRoute } from '@tanstack/react-router';

import { AllListsPage } from '../features/supply/lists/components/AllListsPage/AllListsPage';
import { listsRouteSearchSchema } from '../features/supply/lists/listsRouteSearch';

export const Route = createFileRoute('/supply/lists/all')({
  validateSearch: listsRouteSearchSchema,
  component: AllListsPage,
});
